<div class="flex flex-col items-center py-8">
  <div>
    <img [src]="imageSrc" />
  </div>
  <h3 nz-typography class="mt-6" nzType="secondary">
    {{ titleResource | translate }}
  </h3>
  <div nz-typography nzType="secondary" class="mt-2 text-center">
    {{ descriptionResource | translate }}
  </div>
</div>
